import request from '@/utils/request'
import { addQueryToUrl } from '@/utils/utils'

const payApi = process.env.VUE_APP_PAY_API

// 采购人收费记录
export function getRevenueListApi(params) {
  return request({
    url: payApi + '/v1/order/page/seller',
    method: 'get',
    params
  })
}

// 采购人收入单统计
export function getRevenueStatisticApi(params) {
  return request({
    url: payApi + '/v1/order/seller/count',
    method: 'get',
    params
  })
}

// 采购人端发票申请记录
export function getInvoiceApplyListApi(params) {
  return request({
    url: payApi + '/v1/invoiceApply/page/seller',
    method: 'get',
    params
  })
}

// 获取发票下载列表
export function getInvoiceDownloadListApi(id) {
  return request({
    url: payApi + `/v1/invoiceApply/invoiceDetail/List/${id}`,
    method: 'get'
  })
}

// 批量开票
export function batchInvoicingApi(data) {
  return request({
    url: payApi + '/v1/invoiceApply/agreeBatch',
    method: 'post',
    data
  })
}

// 同意开票
export function agreeInvoiceApi(id, data) {
  return request({
    url: payApi + `/v1/invoiceApply/agree/${id}`,
    method: 'patch',
    data
  })
}

// 同意并修改发票
export function agreeInvoiceChangeApi(id, data) {
  return request({
    url: payApi + `/v1/invoiceApply/agreeModify/${id}`,
    method: 'patch',
    data
  })
}

// 拒绝开票
export function rejectInvoiceApi(id, data) {
  return request({
    url: payApi + `/v1/invoiceApply/reject/${id}`,
    method: 'patch',
    data
  })
}

// 根据主键id查询发票地址
export function getInvoiceByIdApi(invoiceAddressId, params) {
  return request({
    url: payApi + `/v1/invoiceAddress/${invoiceAddressId}`,
    method: 'get',
    params
  })
}

// 分页查询提现记录
export function getWithdrawalListApi(params) {
  return request({
    url: payApi + '/v1/withdraw/page',
    method: 'get',
    params
  })
}

// 余额和提现金额统计
export function getWithdrawalBalanceApi() {
  return request({
    url: payApi + '/v1/withdraw/accountBalance',
    method: 'get'
  })
}

// 采购人发票记录支付单详情
export function getInvoicePayListApi(invoiceApplyId) {
  return request(
    {
      url: payApi + `/v1/order/${invoiceApplyId}/seller`,
      method: 'get'
    },
    true
  )
}

// 保证金对账单查询
export function getDepositStatementsApi(params) {
  return request(
    {
      url: payApi + '/v1/depositReceiptEntry/depositOrderGrid',
      method: 'get',
      params
    },
    true
  )
}

// 保证金对账单统计查询
export function getDepositStatementsStatisticsApi(params) {
  return request(
    {
      url: payApi + '/v1/depositReceiptEntry/depositOrder/count',
      method: 'get',
      params
    },
    true
  )
}

// 保证金对账单导出
export function exportDepositStatementsApi(params) {
  window.open(
    addQueryToUrl(
      `${payApi}/v1/depositReceiptEntry/depositOrder/export`,
      params
    ),
    '_blank'
  )
}

// 获取发票地址
export function getInvoiceApi(params) {
  return request(
    {
      url: payApi + '/v1/invoiceAddress',
      method: 'get',
      params
    },
    {
      needLoading: true
    }
  )
}

// 获取开票企业合集
export function getInvoiceCompanyApi() {
  return request({
    url: payApi + '/v1/invoiceAddressJoinCompany',
    method: 'get'
  })
}

// 获取个人开票信息
export function getPersonalInvoiceApi() {
  return request({
    url: payApi + '/v1/getInvoiceUserInfo',
    method: 'get'
  })
}
